import { useState, useContext } from "react";
import Typography from "@material-ui/core/Typography";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import StatusSummaryDrawer from "../StatusSummaryDrawer";
import DataService from "../../../../../../Service";
import { miIconsAssigner } from "../MIIconsAssignor";
import { useQuery } from "react-query";
import { MIContext } from "../MIContext";
import MIStyles from "../MIStyles";
import { useSelector } from "react-redux";

function FilterCard(props) {
  const [drawer, setDrawer] = useState(false);

  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData.role;
  const orgId = globaluserData.organisation_id;

  const { statisticsFilter, setStatisticsFilter } = props;

  // query-func
  const fetchStatistics = () => {
    const statisticsParams = {
      type: "admin",
    };
    if (userRole === "employee") {
      statisticsParams.type = "organisation";
      statisticsParams.organisation_id = orgId;
    }
    return DataService.getDirectData(
      "/assignments/statistics",
      statisticsParams
    );
  };

  // query-key
  let statisticsQueryKey = [
    "mi-statistics",
    userRole,
    userRole === "admin" ? "" : orgId || "",
  ];

  // query
  const { data, isLoading } = useQuery(statisticsQueryKey, fetchStatistics, {
    staleTime: 300000,
    onSuccess: (res) => {
      const stats = {};
      res.statistics.forEach((el) => {
        stats[el.label.toLowerCase()] = el.value;
      });
    },
    placeholderData: { statistics: [] },
  });

  const statisticsToDisplay = data?.statistics.slice(0, 6) || [];

  if (isLoading) {
    return (
      <Box width="100%" display={"flex"} justifyContent={"center"}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 20 }}
        spacing={2}
      >
        {isLoading ? "Loading" : null}
        {statisticsToDisplay?.map((option, i) => {
          return (
            <Grid item xs={3} key={i}>
              <Card
                isSelected={statisticsFilter === option.label}
                onClick={() => {
                  setStatisticsFilter(option.label);
                }}
                label={option.label}
                value={option.value}
                component="button"
              />
            </Grid>
          );
        })}
        <Grid item xs={3}>
          <Card
            label="View all statistics"
            onClick={() => {
              setDrawer(true);
            }}
            value=""
            isSelected={
              !statisticsToDisplay
                .map((el) => el.label)
                .includes(statisticsFilter)
            }
            component="div"
          />
        </Grid>
      </Grid>
      {drawer && (
        <StatusSummaryDrawer
          parentCall={setDrawer}
          statistics={data.statistics}
          {...props}
        />
      )}
    </div>
  );
}

const Card = (props) => {
  const classes = MIStyles();
  const { onClick, label, value, isSelected, component } = props;
  return (
    <Box
      width={"100%"}
      component={component}
      boxShadow={2}
      p={0}
      borderRadius={5}
      onClick={onClick}
      style={{
        cursor: "pointer",
        backgroundColor: "#fff",
        border: 0,
        borderLeft: `${isSelected ? 3 : 0}px solid #077F83`,
      }}
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ padding: component === "div" ? 16 : 24 }}
        spacing={2}
      >
        <Grid item xs={8}>
          <Typography
            variant="h2"
            style={{
              color: component === "div" ? "#077F83" : "#320032",
              fontWeight: component === "div" ? "bold" : "normal",
              textAlign: "left",
            }}
          >
            {label}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: "bold",
              color: "#320032",
              textAlign: "left",
            }}
          >
            {value}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Box className={classes.IconBorder}>{miIconsAssigner(label)}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default FilterCard;
